import _ from "lodash";
export const OmitFromArrayValues = ({ arr, omitKeys }) => {
  return _.map(arr, obj => _.omit(obj, omitKeys));
};
